import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import css from './CollapsedPanelValues.css';
import Icon, { IconSizes } from '../foundations/Icon';

export const MAX_VISIBLE_VALUES = 10;

const CollapsedPanelValues = ({
    values,
    itemKeys,
    itemClassName,
    containerClassName,
    onDelete,
    shouldSliceValues = false,
    isReadOnly = false,
}) => {
    const visibleValues = shouldSliceValues ? values.slice(0, MAX_VISIBLE_VALUES) : values;
    const remainingCount = values.length - MAX_VISIBLE_VALUES;
    // When values can collide (e.g. look-alike labels), itemKeys supplies a stable
    // unique id per chip for the React key and the delete callback.
    const keyFor = (value, index) => (itemKeys ? itemKeys[index] : value);

    return (
        <div className={classNames(css.collapsedContentContainer, containerClassName)}>
            {visibleValues.map((value, index) => (
                <div key={`collapsed_${keyFor(value, index)}`} className={classNames(css.collapsedItem, itemClassName)}>
                    {value}
                    {onDelete && !isReadOnly && (
                        <Icon name="x" size={IconSizes.X_SMALL} onClick={() => onDelete(keyFor(value, index))} />
                    )}
                </div>
            ))}
            {shouldSliceValues && remainingCount > 0 && (
                <div className={classNames(css.collapsedItem, css.moreItem)}>+{remainingCount} more</div>
            )}
        </div>
    );
};

CollapsedPanelValues.propTypes = {
    values: PropTypes.arrayOf(PropTypes.node).isRequired,
    // Optional stable ids parallel to values; used for the React key and onDelete
    // arg when the rendered values are not guaranteed unique.
    itemKeys: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
    itemClassName: PropTypes.string,
    containerClassName: PropTypes.string,
    onDelete: PropTypes.func,
    shouldSliceValues: PropTypes.bool,
    isReadOnly: PropTypes.bool,
};

export default CollapsedPanelValues;
